import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const MapMarkerLBOFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M12.0001 21.2195C11.5606 20.7601 11.1487 20.3239 10.7628 19.9089C5.98978 14.776 5.18652 12.8769 5.18652 10.3667C5.18652 6.71506 8.30772 3.61426 12.0001 3.61426C15.6925 3.61426 18.8137 6.71506 18.8137 10.3667C18.8137 12.8769 18.0105 14.776 13.2374 19.9089C12.8515 20.3239 12.4396 20.7601 12.0001 21.2195ZM11.19 8.69999C11.19 9.36272 10.6528 9.89997 9.99003 9.89997C9.32729 9.89997 8.79004 9.36272 8.79004 8.69999C8.79004 8.03725 9.32729 7.5 9.99003 7.5C10.6528 7.5 11.19 8.03725 11.19 8.69999ZM15.8101 11.7C15.8101 12.3627 15.2729 12.9 14.6101 12.9C13.9474 12.9 13.4102 12.3627 13.4102 11.7C13.4102 11.0373 13.9474 10.5 14.6101 10.5C15.2729 10.5 15.8101 11.0373 15.8101 11.7ZM15.218 7.66187H13.3487L8.84204 13.2778H10.7113L15.218 7.66187Z"
      />
    </SvgIcon>
  );
});
